"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeepAliveUrl = exports.getTopMilestonesUrl = exports.getPriceChangeUrl = exports.getAvgPriceUrl = exports.getTokenPriceUrl = exports.getUpdatedAfterUrl = exports.getManyAdvancedUrl = exports.getManyUrl = exports.getManyByIdUrl = exports.getByIdUrl = exports.Build5Env = void 0;
const interfaces_1 = require("@build-5/interfaces");
var Build5Env;
(function (Build5Env) {
    Build5Env["PROD"] = "https://api.build5.com/api";
    Build5Env["TEST"] = "https://api-test.build5.com/api";
    Build5Env["DEV"] = "https://soonaverse-dev.web.app/api";
    Build5Env["LOCAL"] = "http://127.0.0.1:5001/soonaverse-dev/us-central1/api";
})(Build5Env = exports.Build5Env || (exports.Build5Env = {}));
const getByIdUrl = (baseUrl) => baseUrl + interfaces_1.ApiRoutes.GET_BY_ID;
exports.getByIdUrl = getByIdUrl;
const getManyByIdUrl = (baseUrl) => baseUrl + interfaces_1.ApiRoutes.GET_MANY_BY_ID;
exports.getManyByIdUrl = getManyByIdUrl;
const getManyUrl = (baseUrl) => baseUrl + interfaces_1.ApiRoutes.GET_MANY;
exports.getManyUrl = getManyUrl;
const getManyAdvancedUrl = (baseUrl) => baseUrl + interfaces_1.ApiRoutes.GET_MANY_ADVANCED;
exports.getManyAdvancedUrl = getManyAdvancedUrl;
const getUpdatedAfterUrl = (baseUrl) => baseUrl + interfaces_1.ApiRoutes.GET_UPDATED_AFTER;
exports.getUpdatedAfterUrl = getUpdatedAfterUrl;
const getTokenPriceUrl = (baseUrl) => baseUrl + interfaces_1.ApiRoutes.GET_TOKEN_PRICE;
exports.getTokenPriceUrl = getTokenPriceUrl;
const getAvgPriceUrl = (baseUrl) => baseUrl + interfaces_1.ApiRoutes.GET_AVG_PRICE;
exports.getAvgPriceUrl = getAvgPriceUrl;
const getPriceChangeUrl = (baseUrl) => baseUrl + interfaces_1.ApiRoutes.GET_PRICE_CHANGE;
exports.getPriceChangeUrl = getPriceChangeUrl;
const getTopMilestonesUrl = (baseUrl) => baseUrl + interfaces_1.ApiRoutes.GET_TOP_MILESTONES;
exports.getTopMilestonesUrl = getTopMilestonesUrl;
const getKeepAliveUrl = (baseUrl) => baseUrl + interfaces_1.ApiRoutes.KEEP_ALIVE;
exports.getKeepAliveUrl = getKeepAliveUrl;
